// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentHoldingDetailsDto } from './IInvestmentHoldingDetailsDto';
import {
    IInvestmentHoldingDetailsDtoFromJSON,
    IInvestmentHoldingDetailsDtoFromJSONTyped,
    IInvestmentHoldingDetailsDtoToJSON,
    IInvestmentHoldingDetailsDtoToJSONTyped,
} from './IInvestmentHoldingDetailsDto';

/**
 * 
 * @export
 * @interface IInvestmentCashHoldingDetailsDto
 */
export interface IInvestmentCashHoldingDetailsDto extends IInvestmentHoldingDetailsDto {
}

/**
 * Check if a given object implements the IInvestmentCashHoldingDetailsDto interface.
 */
export function instanceOfIInvestmentCashHoldingDetailsDto(value: object): value is IInvestmentCashHoldingDetailsDto {
    return true;
}

export function IInvestmentCashHoldingDetailsDtoFromJSON(json: any): IInvestmentCashHoldingDetailsDto {
    return IInvestmentCashHoldingDetailsDtoFromJSONTyped(json, false);
}

export function IInvestmentCashHoldingDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentCashHoldingDetailsDto {
    return json;
}

export function IInvestmentCashHoldingDetailsDtoToJSON(json: any): IInvestmentCashHoldingDetailsDto {
    return IInvestmentCashHoldingDetailsDtoToJSONTyped(json, false);
}

export function IInvestmentCashHoldingDetailsDtoToJSONTyped(value?: IInvestmentCashHoldingDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

